var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loading-wrapper"},[_c('div',{staticClass:"custom-loading"},[_c('div',{staticClass:"bg-primary rect1"}),_c('div',{staticClass:"bg-primary rect2"}),_c('div',{staticClass:"bg-primary rect3"}),_c('div',{staticClass:"bg-primary rect4"}),_c('div',{staticClass:"bg-primary rect5"})])])
}]

export { render, staticRenderFns }